import request from '@/utils/requestWrapper'

// 获取名片列表
export function getCardList (params) {
  return request({
    url: '/api/card/list',
    method: 'get',
    params
  })
}

// 新增名片
export function addCard (data) {
  return request({
    url: '/api/card/save',
    method: 'post',
    data
  })
}

// 更新名片信息
export function updateCard (cardId, data) {
  return request({
    url: `/api/card/update/${cardId}`,
    method: 'put',
    data
  })
}

// 删除名片
export function deleteCard (cardId) {
  return request({
    url: `/api/card/delete/${cardId}`,
    method: 'delete'
  })
}

// 获取名片信息
export function getCardById (cardId) {
  return request({
    url: `/api/card/info/${cardId}`,
    method: 'get'
  })
}

// 获取动态名片数据
export function getDynamicCard (id, visitorInfo) {
  return request({
    url: `/api/card/dynamic/${id}`,
    method: 'get',
    params: visitorInfo
  })
}

// 获取名片信息 - 兼容旧版
export function getCardInfo (cardId) {
  return getCardById(cardId)
}

// 分享名片 - 后端暂未实现
export function shareCard (cardId) {
  return request({
    url: `/api/card/share/${cardId}`,
    method: 'post'
  })
}

// 获取分享记录 - 后端暂未实现
export function getShareRecords (params) {
  return request({
    url: '/api/card/share/records',
    method: 'get',
    params
  })
}

// 设置默认名片 - 后端暂未实现
export function setDefaultCard (cardId) {
  return request({
    url: `/api/card/set-default/${cardId}`,
    method: 'post'
  })
}

// 获取名片统计信息
export function getCardStats (cardId) {
  return request({
    url: `/api/card/stats/${cardId}`,
    method: 'get'
  })
}
